import { useState, useEffect } from "react";
import SectionNoDataComponent from "../../CoreComponents/SectionNoDataComponent";
import { protocol, token, url } from "../../Functionalities/Config";
import axios from "axios";
import { showMessage } from "../../Functionalities/Functions";
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import NoImage from "../../Assets/images/no-image.png";
import { confirmAlert } from "react-confirm-alert";

function RestaurantSection({ data, remove, priority, refreshData }) {
  // void 0
  const [Active, setActive] = useState(data.is_active == true ? true : false);

  useEffect(() => {
    //  alert(data.is_active)
    setActive(data.is_active);
    updateCharacters(data.is_branch);
  }, [data]);

  const changeState = () => {
    let fdata = new FormData();
    fdata.append("keyword", "update_section_status");
    fdata.append("status", Active ? "false" : "true");
    fdata.append("section_id", data.id);

    let config = {
      method: "patch",
      url: url + "/items/sections/",
      headers: {
        Authorization: token,
      },
      data: fdata,
    };

    axios(config)
      .then((res) => {
        if (res.data.Status) {
          showMessage(
            "Status updated",
            "success",
            "Success!",
            "top",
            "top-right",
            0,
          );
          refreshData();
        } else {
          showMessage(
            "Status update failed",
            "danger",
            "Failed!",
            "top",
            "top-right",
            0,
          );
        }
      })
      .catch((err) => {
        showMessage(
          "Status update failed",
          "danger",
          "Failed!",
          "top",
          "top-right",
          0,
        );
      });
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = list;
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const grid = 8;

  const getItemStyle = (draggableStyle, isDragging) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    color: "black",
    border: "1px solid",
    borderRadius: ".5rem",
    // change background cmolour if dragging
    background: "white",
    borderColor: isDragging ? "#FB310D" : "lightgray",

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    //   background: isDraggingOver ? "yellow" : "white",
    padding: grid,
    //   width: 250,
  });

  // const onDragEnd = async(result) => {
  //   void 0

  //   // dropped outside the list
  //   if (!result.destination) {
  //     return;
  //   }

  //   const newItems = reorder(
  //     Items,
  //     result.source.index,
  //     result.destination.index
  //   );

  //   setItems(newItems);

  //   let item_ids = []
  //   // void 0
  //   await newItems.map((item)=>
  //     {
  //       void 0
  //       item_ids.push(item.id)

  //     }
  //   )
  //   // void 0
  //   // setItem_ids(item_ids)
  //   // reorderItems(item_ids)

  // };

  const [characters, updateCharacters] = useState([]);

  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    updateCharacters(items);

    let rankArray = [];
    for (var i = 0; i < items.length; i++) {
      rankArray.push(items[i].id);
    }

    var fdata = new FormData();

    fdata.append("keyword", "update_branchs");
    fdata.append("order_lst", JSON.stringify(rankArray));
    fdata.append("section_id", data.id);

    var config = {
      method: "patch",
      url: url + "/items/sections/",
      headers: {
        Authorization: token,
      },
      data: fdata,
    };

    axios(config)
      .then(function (response) {
        if (response.data.Status == true) {
          showMessage(
            "Position updated",
            "success",
            "Success!",
            "top",
            "top-right",
            0,
          );
        } else {
          showMessage(
            "Position updated failed",
            "danger",
            "Failed!",
            "top",
            "top-right",
            0,
          );
        }
      })
      .catch(function (error) {
        showMessage(
          "Position updated failed",
          "danger",
          "Failed!",
          "top",
          "top-right",
          0,
        );
      });
  }

  const handleChangeActive = (status, itemId) => {

    var fdata = new FormData();
    fdata.append("keyword", "update_section_inner_data_status");
    fdata.append("type", "update_branchs");
    fdata.append("update_list", JSON.stringify([itemId]));
    fdata.append("section_id", data.id);
    fdata.append("status", status);

    var config = {
      method: "patch",
      url: url + "/items/sections/",
      headers: {
        Authorization: token,
      },
      data: fdata,
    };

    axios(config)
      .then(function (response) {
        if (response.data.Status) {
          showMessage(
            "Status updated",
            "success",
            "Success!",
            "top",
            "top-right",
            0,
          );
          refreshData();
        } else {
          showMessage(
            "Status update failed",
            "danger",
            "Failed!",
            "top",
            "top-right",
            0,
          );
        }
      })
      .catch(function (error) {
        showMessage(
          "Status update failed",
          "danger",
          "Failed!",
          "top",
          "top-right",
          0,
        );
      });
  };

  const deleteBranch = (itemId) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div
            className="custom-ui"
            style={{
              borderRadius: 8,
              border: "solid",
              padding: 70,
              borderWidth: 0.5,
            }}
          >
            <h1>Are you sure?</h1>
            <p>Press remove to remove this branch from the section</p>
            <button
              onClick={onClose}
              className="btn btn-primary"
              style={{ marginRight: 10 }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                var fdata = new FormData();
                fdata.append("keyword", "remove_branch");
                fdata.append("branch_list", JSON.stringify([itemId]));
                fdata.append("id", data.id);

                var config = {
                  method: "put",
                  url: url + "/items/sections/",
                  headers: {
                    Authorization: token,
                  },
                  data: fdata,
                };

                axios(config)
                  .then(function (response) {
                    if (response.data.Status) {
                      showMessage(
                        "Section updated",
                        "success",
                        "Success!",
                        "top",
                        "top-right",
                        0,
                      );
                      // refreshData()
                      window.location.reload();
                    } else {
                      showMessage(
                        "Section update failed",
                        "danger",
                        "Failed!",
                        "top",
                        "top-right",
                        0,
                      );
                    }
                  })
                  .catch(function (error) {
                    showMessage(
                      "Section update failed",
                      "danger",
                      "Failed!",
                      "top",
                      "top-right",
                      0,
                    );
                  });
              }}
              className="btn btn-primary"
            >
              Remove
            </button>
          </div>
        );
      },
    });
  };

  return (
    <>
      <div className="card m-0">
        <div className="card-header p-0">
          <h5 className="card-title mb-2">
            <img
              src={
                data.icon
                  ? data.icon.image
                    ? data.icon.image
                    : NoImage
                  : NoImage
              }
              alt=""
              style={{ width: "2rem", height: "2rem", objectFit: "cover" }}
            />
            {"  "}
            {data.name}{" "}
            {window.location.pathname.toLowerCase().includes("mobilelandingpage") && (
              <span>
                <i
                  class="fa fa-eye ml-1"
                  style={{ cursor: "pointer", color: "#EF4832" }}
                  onClick={() => (window.location.href = "/section/" + data.id)}
                />
              </span>
            )}
          </h5>
          <button
            className={
              Active
                ? "btn btn-xs btn-outline-primary "
                : "btn btn-xs btn-primary"
            }
            onClick={() => changeState()}
          >
            {Active ? "Disable" : "Activate"}
          </button>
        </div>

        {false && (
          <div className="card-body p-0">
            <div className="basic-list-group">
              <div className="list-group">
                {data.is_branch.length > 0 ? (
                  data.is_branch.map((item, index) => (
                    <div
                      className="list-group-item list-group-item-action flex-column align-items-start p-0"
                      // onClick={()=>remove(item.id,"remove_branch",data)}
                      // onClick={() => {
                      //   if (!openModal) {
                      //     setOpenModal(true)
                      //   }
                      // }}
                    >
                      <div>
                        <div className="d-flex align-items-center ">
                          <div className="list-group-item list-group-item-action flex-column align-items-start px-0 py-3">
                            <div className="d-flex align-items-center w-100">
                              <>
                                <div>
                                  <img
                                    src={
                                      item.images[0]
                                        ? url +
                                          item.images[0].image.replace(
                                            "http://",
                                            protocol,
                                          )
                                        : "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/600px-No_image_available.svg.png"
                                    }
                                    alt=""
                                    style={{
                                      width: "4rem",
                                      height: "4rem",
                                      objectFit: "cover",
                                      borderRadius: ".5rem",
                                    }}
                                  />
                                </div>
                              </>

                              <div className={"ml-2 w-50"}>
                                <div className="d-flex w-100 justify-content-between">
                                  <h6 className="mb-1 text-black ">
                                    {/* {item.heading} */}
                                    {/* restauramts */}
                                    {item.name}
                                  </h6>
                                </div>
                                {/* <p className="mb-1">{item.content}</p> */}
                                <small className="text-muted">
                                  {item.description}
                                </small>
                              </div>

                              <div>
                                <div className="round-btn-wrapper-rest">
                                  <div
                                    className="checkbox switcher d-flex"
                                    style={{ alignItems: "center" }}
                                  >
                                    <label for="test" style={{ margin: 0 }}>
                                      <input
                                        type="checkbox"
                                        id="test"
                                        value=""
                                      />
                                      <span>
                                        <small></small>
                                      </span>
                                      {/* <small>Light switch</small> */}
                                    </label>
                                  </div>

                                  <button
                                    className="round-button"
                                    title={"remove"}
                                  >
                                    <i className="fa fa-trash text-primary"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <SectionNoDataComponent data="Items found" />
                )}
              </div>
            </div>
          </div>
        )}
        <div className="card-body p-0">
          <div className="basic-list-group">
            <div className="list-group">
              <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="droppable">
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver)}
                      {...provided.droppableProps}
                    >
                      {characters.map((item, index) => {
                        // void 0
                        return (
                          <Draggable
                            key={item.id}
                            draggableId={item.id.toString()}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <div>
                                <div
                                  ref={provided.innerRef}
                                  {...provided.dragHandleProps}
                                  {...provided.draggableProps}
                                  style={getItemStyle(
                                    provided.draggableProps.style,
                                    snapshot.isDragging,
                                  )}
                                >
                                  {/* {item.name} */}
                                  <div
                                    className="list-group-item list-group-item-action flex-column align-items-start p-0"
                                    // onClick={()=>remove(item.id,"remove_branch",data)}
                                    // onClick={() => {
                                    //   if (!openModal) {
                                    //     setOpenModal(true)
                                    //   }
                                    // }}
                                  >
                                    <div>
                                      <div className="d-flex align-items-center ">
                                        <div className="list-group-item list-group-item-action flex-column align-items-start px-0 py-3">
                                          <div className="d-flex align-items-center w-100">
                                            <>
                                              <div>
                                                <img
                                                  src={
                                                    item.images[0]
                                                      ? url +
                                                        item.images[0].image.replace(
                                                          "http://",
                                                          protocol,
                                                        )
                                                      : "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/600px-No_image_available.svg.png"
                                                  }
                                                  alt=""
                                                  style={{
                                                    width: "4rem",
                                                    height: "4rem",
                                                    objectFit: "cover",
                                                    borderRadius: ".5rem",
                                                  }}
                                                />
                                              </div>
                                            </>

                                            <div className={"ml-2 w-50"}>
                                              <div className="d-flex w-100 justify-content-between">
                                                <h6 className="mb-1 text-black ">
                                                  {/* {item.heading} */}
                                                  {/* restauramts */}
                                                  {item.name}
                                                </h6>
                                              </div>
                                              {/* <p className="mb-1">{item.content}</p> */}
                                              <small className="text-muted">
                                                {item.description}
                                              </small>
                                            </div>

                                            <div>
                                              <div className="round-btn-wrapper-rest">
                                                {false && (
                                                  <div
                                                    className="checkbox switcher d-flex"
                                                    style={{
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <label
                                                      for="test"
                                                      style={{ margin: 0 }}
                                                    >
                                                      {/* <input type="checkbox" id="test" checked={item.is_active} onClick={(e) => {alert(item.id);}} /> */}
                                                      <div
                                                        onClick={(e) => {
                                                          alert(item.id);
                                                        }}
                                                      >
                                                        ss
                                                      </div>
                                                      <span>
                                                        <small></small>
                                                      </span>
                                                      {/* <button onClick={()=> alert(item.id)}>x</button> */}
                                                      {/* <small>Light switch</small> */}
                                                    </label>
                                                  </div>
                                                )}
                                                <label class="switch">
                                                  <input
                                                    checked={item.is_active}
                                                    onChange={(e) =>
                                                      handleChangeActive(
                                                        e.target.checked,
                                                        item.id,
                                                      )
                                                    }
                                                    type="checkbox"
                                                    id="togBtn"
                                                  />
                                                  <div class="slider round">
                                                    <span class="on">ON</span>
                                                    <span class="off">OFF</span>
                                                  </div>
                                                </label>

                                                <button
                                                  className="round-button"
                                                  title={"remove"}
                                                  onClick={() => {
                                                    deleteBranch(item.id);
                                                  }}
                                                >
                                                  <i className="fa fa-trash text-primary"></i>
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RestaurantSection;
